import axios from 'axios';
import { isEmpty, get } from 'lodash-es';
import { handleApi, handleSessionLessApi } from './common';
import { SCRIP_INSTRUMENTS } from '../constants/scripDetail';
import { COMMON } from '../strings/common';
const STRING = COMMON;

const OPTION_CHAIN_PAGE_SIZE = 40;
export const WAVE_ENV = 'prod';
const WAVE_SERVER_URL = {
	prod: {
		url: 'https://waveapi.odinwave.com/',
	},
	uat: {
		url: 'https://uatwaveapi.odinwave.com/',
	},
	preProd: {
		url: 'https://waveapi.odinwave.com/',
	},
	wavePreProd: {
		url: 'https://waveapi.odinwave.com/',
	},
};

export const ODIN_SERVER_URL = WAVE_SERVER_URL[WAVE_ENV].url;
export const get_option_expiry_dates = async (Api, token, segment_id) => {
	try {
		const body = {
			token: String(token),
			instrument: 'option',
			segment_id: String(segment_id),
		};
		const res = await Api.post(API_ENDPOINTS.optionExpiryDates, body);
		return handleApi(res);
	} catch (e) {
		throw new Error('error in get_option_expiry_dates');
	}
};

export const get_new_option_chain = async (Api, params) => {
	const { asset_token, instrument, exp_date, spot_price, segment_id } =
		params;
	try {
		const body = {
			asset_token,
			instrument,
			exp_date,
			spot_price: parseInt(spot_price, 10),
			page_size_above: OPTION_CHAIN_PAGE_SIZE / 2,
			page_size_below: OPTION_CHAIN_PAGE_SIZE / 2,
			segment_id: String(segment_id),
		};
		const res = await Api.get(API_ENDPOINTS.optionChainNew, body);
		return handleApi(res);
	} catch (e) {
		throw new Error('error in get_new_option_chain');
	}
};

export const get_futures_list = async (Api, symbol, selectedInstrument) => {
	try {
		const body = {
			instrument: selectedInstrument || SCRIP_INSTRUMENTS.FUTURES,
			symbol,
		};
		const res = await Api.post(API_ENDPOINTS.scripDetail, body);
		return handleApi(res);
	} catch (e) {
		console.log('error in get_futures_list', e.message);
	}
};

export const get_live_market_data = async (tenantId) => {
	try {
		const res = await axios.get(
			`${ODIN_SERVER_URL}nontransactional/${tenantId}/v1/marketStatus`,
		);
		return res;
	} catch (e) {
		console.log('error in get_live_market_data', e.message);
	}
};

export const get_scrip_logo = async (marketSegment, token) => {
	try {
		const scripImageData = await axios.get(
			`${ODIN_SERVER_URL}cds/1652/v1/${marketSegment}/${token}/GetCompanyLogo`,
		);
		const logourl = get(
			scripImageData,
			'data.ResponseObject.resultset',
			'',
		);
		return logourl;
	} catch (e) {
		console.log(e.message);
	}
};

export const get_brand_logo = async (marketSegment, token) => {
	try {
		const scripImageData = await axios.get(
			`${ODIN_SERVER_URL}cds/1652/v1/${marketSegment}/${token}/getBrandLogos`,
		);
		const res = get(scripImageData, 'data.ResponseObject.resultset', '');
		return res;
	} catch (e) {
		console.log(e.message);
	}
};

export const get_wave2_token = async (Api) => {
	try {
		const defaultErrorMessage = STRING.genericErrorMessage;
		const res = await Api.get(API_ENDPOINTS.getToken);
		if (
			res.pfwstatus_code !== 200 ||
			!res.pfwresponse ||
			isEmpty(res.pfwresponse)
		) {
			throw new Error(res?.pfwmessage || defaultErrorMessage);
		}
		const { result, status_code: status } = res.pfwresponse;
		if (status === 200 || status === 405) {
			return { result, status };
		} else {
			throw new Error(
				result.message || result.error || defaultErrorMessage,
			);
		}
	} catch (e) {
		throw e;
	}
};

export const getWave2Downtime = async (Api) => {
	try {
		const res = await Api.get(API_ENDPOINTS.getDownTime);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const getPaymentUrl = async (Api, params = {}) => {
	const res = await Api.post(API_ENDPOINTS.getUrl, params);
	if (res.pfwstatus_code === 416) {
		throw new Error('2FA Required');
	} else {
		return handleApi(res);
	}
};

export const getScripSearch = async (Api, searchtext, mktallowed = 0) => {
	try {
		const res = await Api.get(
			API_ENDPOINTS.getScripSearch(searchtext, mktallowed),
		);
		return res;
	} catch (err) {
		throw err;
	}
};

export const generateWaveToken = async (Api) => {
	try {
		const body = {};
		const res = await Api.post(API_ENDPOINTS.login, body);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_health_score = async (Api, marketSegmentId, nToken) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: nToken,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_health_total_score'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_financial_ratio = async (
	Api,
	marketSegmentId,
	nToken,
	type,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: nToken,
			type,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_company_financial_ratio_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_quarterly_trend = async (
	Api,
	exchange,
	nToken,
	trendType,
) => {
	try {
		const body = {
			exchange: exchange,
			token: nToken,
			qtlytrend: `QuarterlyTrend-${trendType}`,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_quarterly_trend'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_company_wise_mf_holding_data = async (
	Api,
	marketSegmentId,
	nToken,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: nToken,
			noofrecords: 10,
			psize: '-',
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_company_wise_mf_holding_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_peer_comparison = async (
	Api,
	marketSegmentId,
	nToken,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: nToken,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_peer_comparison'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_company_balance_sheet_data = async (
	Api,
	marketSegmentId,
	nToken,
	type,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: nToken,
			type,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_company_balance_sheet_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_profit_loss_data = async (
	Api,
	marketSegmentId,
	nToken,
	type,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: nToken,
			type,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_profit_loss_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_company_result = async (
	Api,
	marketSegmentId,
	nToken,
	type,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: nToken,
			type,
			period: 'Yearly',
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_company_result_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_share_holding_pattern_data = async (
	Api,
	marketSegmentId,
	nToken,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: nToken,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_share_holding_pattern_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_moving_average = async (Api, token, exchange) => {
	try {
		const body = {
			exchange,
			token,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_moving_average'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_volume_vs_delivery = async (
	Api,
	marketSegmentId,
	token,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: token,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_volume_vs_delivery'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_wise_news_data = async (
	Api,
	marketSegmentId,
	token,
	psize = 10,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: token,
			psize: psize,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_scrip_wise_news_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

// Corporate section api's

export const get_board_meetings_data = async (
	Api,
	marketSegmentId,
	token,
	fromDate,
	toDate,
) => {
	try {
		const body = {
			pno: 1,
			psize: 10,
			marketsegmentid: marketSegmentId,
			token: token,
			fromdate: fromDate,
			todate: toDate,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_board_meetings_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_rights_data = async (Api, exchange, token) => {
	try {
		const body = {
			exchange,
			token,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_rights_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_book_closure = async (Api, marketSegmentId, token) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_book_closure'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_agm_egm_data = async (
	Api,
	mode,
	marketSegmentId,
	token,
	fromDate,
	toDate,
) => {
	try {
		const body = {
			pno: 1,
			psize: 10,
			mode: mode,
			marketsegmentid: marketSegmentId,
			token: token,
			fromdate: fromDate,
			todate: toDate,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_agm_egm_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_splits_data = async (
	Api,
	marketSegmentId,
	token,
	fromDate,
	toDate,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: token,
			fromdate: fromDate,
			todate: toDate,
			recsize: 10,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_splits_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_dividend_data = async (
	Api,
	marketSegmentId,
	token,
	fromDate,
	toDate,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token: token,
			recordsize: 100,
			fromdate: fromDate,
			todate: toDate,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_dividend_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_buy_back = async (Api, marketSegmentId, token) => {
	try {
		const body = {
			exchange: marketSegmentId,
			token: token,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_buy_back'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_corporate_action_calendar_data = async (
	Api,
	type,
	fromDate,
	toDate,
) => {
	try {
		const body = {
			psize: '-',
			noofrecords: 10,
			type,
			fromdate: fromDate,
			todate: toDate,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_corporate_action_calendar_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_analyst_data = async (Api, isin, ltp = '') => {
	try {
		const body = {
			isin: isin,
			cmp: ltp,
		};
		const res = await Api.post(API_ENDPOINTS.anaystData, body);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_security_info = async (Api, marketSegmentId, token) => {
	try {
		const body = {
			mktSegmentId: marketSegmentId,
			token,
		};
		const res = await Api.post(API_ENDPOINTS.securityInfo, body);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_board_of_director_data = async (
	Api,
	marketSegmentId,
	token,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_board_of_director_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_company_history = async (Api, exchange, token) => {
	try {
		const body = {
			exchange: exchange,
			token,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_company_history'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_company_listing_information = async (Api, exchange, token) => {
	try {
		const body = {
			exchange: exchange,
			token,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_company_listing_information'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_company_exchange_data = async (
	Api,
	marketSegmentId,
	token,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_company_exchange_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_company_background_data = async (
	Api,
	marketSegmentId,
	token,
) => {
	try {
		const body = {
			marketsegmentid: marketSegmentId,
			token,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_company_background_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_scrip_details = async (Api, instrument, symbol) => {
	try {
		const body = {
			instrument,
			symbol,
		};
		const res = await Api.post(API_ENDPOINTS.scripDetail, body);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_option_data_forIndex = async (
	Api,
	token,
	pgsize = 10,
	pgindex = 0,
) => {
	try {
		const body = {
			indextoken: token,
			pgindex: pgindex,
			pgsize: pgsize,
		};
		const res = await Api.post(API_ENDPOINTS.optionDataForIndex, body);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};
export const get_option_scrip_details = async (
	Api,
	symbol,
	selectedInstrument,
) => {
	try {
		const body = {
			instrument: selectedInstrument || SCRIP_INSTRUMENTS.OPTIONS,
			symbol,
		};
		const res = await Api.post(API_ENDPOINTS.scripDetail, body);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_index_constituents_data = async (
	Api,
	exchange,
	indexGroup,
	pSize = 10,
) => {
	try {
		const body = {
			exchange: exchange,
			indexgroup: indexGroup,
			psize: pSize,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_index_constituents_data_v2'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const get_put_call_master_data = async (Api, symbol) => {
	try {
		const body = {
			symbol,
		};
		const res = await Api.post(
			API_ENDPOINTS.marketApi('get_put_call_master_data'),
			body,
		);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const generateWaveGuestToken = async (Api, mobile_number) => {
	try {
		const body = {
			mobile_number: mobile_number,
		};
		const res = await Api.post(API_ENDPOINTS.login, body);
		return handleApi(res);
	} catch (err) {
		throw err;
	}
};

export const fetch_master_scrip_detail = async (
	Api,
	token = '',
	marketSegmentId = '',
) => {
	const response = await Api.get(
		API_ENDPOINTS.getMasterScripData(token, marketSegmentId),
	);
	const result = handleApi(response);
	return result;
};

export const fetch_scrip_details_v2 = async (
	Api,
	token = '',
	marketSegmentId = '',
) => {
	const url = API_ENDPOINTS.getScripDetailsV2(token, marketSegmentId);
	const response = await Api.get(url);
	const result = handleSessionLessApi(response);
	return result;
};

export const fetch_future_list_v2 = async (
	Api,
	underlyingToken,
	instrumentType,
	isIndex,
) => {
	const url = API_ENDPOINTS.getFutureListV2(
		underlyingToken,
		instrumentType,
		isIndex,
	);
	const response = await Api.get(url);
	const result = handleSessionLessApi(response);
	return result;
};
export const fetch_valuation = async (Api, data) => {
	const response = await Api.post(
		'api/equity/api/eqm/wave/market/async_fetch',
		data,
	);
	// const result = handleOdinApi(response);
	const result = response?.pfwresponse?.result;
	return result;
};

const API_ENDPOINTS = {
	getToken: '/api/equity/gettoken',
	getDownTime: '/api/equity/api/eqm/downtime/all',
	getUrl: '/api/equity/api/eqm/eqpayments/start/payment',
	getAdditionalData: (moduleName, requestFormat) =>
		`/api/equity/additionaldata/${moduleName}${
			requestFormat ? `?response_format=${requestFormat}` : ''
		}`,
	getScripSearch: (searchText, mktAllowed) =>
		`${ODIN_SERVER_URL}nontransactional/1652/v1/getScripLookUp/${searchText}/${mktAllowed}`,
	login: '/api/equity/api/eqm/wave/login/token',
	marketApi: (marketSection) =>
		`api/equity/api/eqm/wave/market/${marketSection}`,
	anaystData: 'api/equity/additionaldata/analyst_view?response_format=json',
	securityInfo: 'api/equity/api/eqm/wave/scrip/getsecurityinfo',
	scripDetail: 'api/equity/api/eqm/wave/scrip/getscripdetails',
	optionDataForIndex: 'api/equity/api/eqm/wave/scrip/getoptiondataforindex',
	optionExpiryDates: 'api/equity/api/eqm/scrip/master/get_expiry_dates',
	optionChainNew:
		'api/equity/api/eqm/scrip/master/get_scrip_details_from_strike',
	getScripDetailsV2: (token, segmentId) =>
		`scripdetails?token=${token}&segment_id=${segmentId}`,
	getMasterScripData: (nToken, marketSegmentId) =>
		`api/equity/api/eqm/scrip/master/get_scrip_details?token=${nToken}&segment_id=${marketSegmentId}`,
	getFutureListV2: (underlyingToken, instrumentType, isIndex) =>
		`FoDetails?underlying_token=${underlyingToken}&instrument_type=${instrumentType}&is_index=${isIndex}`,
};
